var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem7A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3 96.6c-1.3-14-8.9-21.6-22.9-22.9-14 1.3-21.6 8.9-23 22.9 1.3 13.9 9 21.6 22.9 22.9 14.1-1.3 21.7-9 23-22.9z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.4 72.9C79 74.4 71.1 82.2 69.8 96.5c1.3 14.4 9.2 22.2 23.6 23.6 14.4-1.3 22.2-9.2 23.6-23.6-1.4-14.3-9.2-22.1-23.6-23.6m15.7 8c4.2 4.2 6.4 9.4 6.6 15.7-.2 6.2-2.4 11.5-6.6 15.7s-9.4 6.4-15.7 6.6c-6.2-.2-11.5-2.4-15.7-6.6s-6.4-9.4-6.6-15.7c.2-6.2 2.4-11.5 6.6-15.7s9.4-6.4 15.7-6.6c6.2.2 11.5 2.4 15.7 6.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.2 89.2c-2.5-2.7-5.4-4-8.8-4-2.6 0-5.1.9-7.3 2.7-4.9 4.9-5.3 10.3-1.3 16.2 2.4 2.6 5.3 4 8.8 4 2.7 0 5.2-.9 7.4-2.6 4.6-5.1 5-10.5 1.2-16.3z",
    style: {
      fill: "#999"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 96.5c.1-2.9-.9-5.4-2.9-7.8-2.5-2.9-5.6-4.4-9.3-4.4-2.8-.1-5.4.9-7.8 2.9-2.9 2.5-4.3 5.6-4.4 9.3.1 2.8 1 5.4 2.9 7.8 2.6 2.9 5.7 4.3 9.3 4.4 2.9-.1 5.4-1 7.8-2.9 3-2.6 4.4-5.7 4.4-9.3m-1.3 0c0 3.1-1.3 5.9-3.9 8.3-2 1.7-4.3 2.5-6.9 2.5-3.1-.1-5.9-1.3-8.3-3.9-1.7-2.1-2.5-4.4-2.5-6.9.1-3.1 1.3-5.9 3.9-8.3 2.1-1.7 4.4-2.5 6.9-2.5 3.2 0 6 1.3 8.3 3.9 1.6 2 2.5 4.3 2.5 6.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2 96.6c-.3-3.5-2.2-5.4-5.7-5.7-3.5.3-5.4 2.2-5.7 5.7.3 3.5 2.2 5.4 5.7 5.7 3.5-.3 5.4-2.2 5.7-5.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m113.7 89.4 2.7-.8c-4.4-10.3-12.1-15.7-22.9-16.2-2.7-.1-5.4.4-8.1 1.3-10.2 4.4-15.6 11.8-16.2 22.4v30.7h2.7V96.2c.6-9.3 5.4-15.9 14.3-19.7 2.4-.9 4.8-1.3 7.2-1.3 9.7.3 16.5 5.1 20.3 14.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.5 129.8c-.4-4.9-3.1-7.6-8.1-8.1-4.9.5-7.6 3.2-8.1 8.1.5 4.9 3.2 7.6 8.1 8.1 5-.4 7.7-3.1 8.1-8.1m-3.3 0c-.2 2.9-1.8 4.5-4.7 4.7-2.9-.2-4.4-1.8-4.7-4.7.3-2.9 1.9-4.4 4.7-4.7 2.9.3 4.4 1.9 4.7 4.7z",
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.6 129.8c.5 5.4 3.4 8.3 8.8 8.8 5.4-.4 8.3-3.4 8.8-8.8-.4-5.3-3.4-8.3-8.8-8.8-5.4.5-8.3 3.4-8.8 8.8m13.9-5.3c1.4 1.4 2.1 3.1 2.2 5.2-.1 2.1-.8 3.8-2.2 5.2s-3.1 2.1-5.2 2.2c-2.1-.1-3.8-.8-5.2-2.2s-2.1-3.1-2.2-5.2c.1-2.1.8-3.8 2.2-5.2 1.4-1.4 3.1-2.1 5.2-2.2 2.1.1 3.8.8 5.2 2.2m.2 5.3c-.3-3.3-2.1-5.1-5.4-5.4-3.3.3-5.1 2.1-5.4 5.4.3 3.3 2.1 5.1 5.4 5.4 3.3-.3 5.1-2.1 5.4-5.4m-5.4-4.1c2.5.3 3.8 1.6 4 4-.2 2.5-1.6 3.8-4 4-2.4-.2-3.8-1.6-4-4 .2-2.4 1.6-3.7 4-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.4 96.6c-1.3-14-8.9-21.6-22.9-22.9-13.9 1.3-21.6 8.9-22.9 22.9 1.3 13.9 9 21.6 22.9 22.9 14-1.3 21.6-9 22.9-22.9z",
    style: {
      fill: "#fff"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.4 72.9c-14.3 1.4-22.2 9.3-23.6 23.6 1.4 14.4 9.3 22.2 23.6 23.6 14.4-1.3 22.3-9.2 23.6-23.6-1.3-14.3-9.2-22.1-23.6-23.6m15.7 8c4.2 4.2 6.4 9.4 6.6 15.7-.2 6.2-2.4 11.5-6.6 15.7-4 4.2-9.3 6.4-15.7 6.6-6.2-.2-11.5-2.4-15.7-6.6s-6.3-9.4-6.4-15.7c.1-6.2 2.2-11.5 6.4-15.7s9.4-6.4 15.7-6.6c6.4.2 11.6 2.4 15.7 6.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.9 91.8c-2.3-4.3-5.8-6.5-10.4-6.6-1.6 0-3.1.3-4.7 1-6.1 3.6-7.9 8.7-5.6 15.3 2.3 4.3 5.8 6.5 10.4 6.6 1.6 0 3.2-.3 4.8-1 6-3.6 7.9-8.7 5.5-15.3z",
    style: {
      fill: "#999"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.7 96.5c0-1.8-.3-3.5-1-5.1-2.5-4.6-6.2-7-11.1-7.1-1.7-.1-3.4.3-5.1 1.2-4.5 2.4-6.9 6.1-7.1 11-.1 1.7.3 3.4 1.2 5.1 2.4 4.6 6.1 7 11 7.1 1.8 0 3.5-.4 5.2-1.2 4.5-2.4 6.8-6 6.9-11m-2.4-4.5c.7 1.5 1 3 1 4.5-.2 4.4-2.2 7.6-6.2 9.8-1.5.7-3 1-4.5 1-4.4-.2-7.6-2.2-9.8-6.2-.7-1.5-1-3-1-4.5.1-4.4 2.2-7.6 6.2-9.8 1.5-.7 3-1 4.5-1 4.4.1 7.6 2.1 9.8 6.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M194.2 96.6c-.3-3.5-2.2-5.4-5.7-5.7-3.4.3-5.3 2.2-5.7 5.7.4 3.5 2.3 5.4 5.7 5.7 3.4-.3 5.3-2.2 5.7-5.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M212.9 105.3c.1-4.9 0-7.9-.2-9.1-.5-10.6-5.8-18-16-22.4-2.8-1-5.5-1.4-8.3-1.3-10.8.4-18.5 5.8-22.9 16.2l2.7.8c4-9.2 10.7-13.9 20.2-14.3 2.4.1 4.8.5 7.2 1.3 9 3.8 13.8 10.4 14.3 19.7v30.6h2.7c.2-2.6.2-9.8.3-21.5zM159 216.5v-29.1h-36.1v29.1H159z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M159.7 217v-30.5h-37.4V217h37.4m-1.3-29.1v27.8h-34.7v-27.8h34.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m146.3 187.3-2.2-7.1h-6.4l-2.2 7.1h10.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m146.9 187.1-2.4-7.6h-7.4l-2.4 7.6-.3.8h12.8l-.3-.8m-3.4-6 1.8 5.6h-8.9l1.8-5.6h5.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5 177.3c-.5-5.7-3.7-8.9-9.6-9.4-5.8.5-9 3.7-9.6 9.4.6 5.9 3.8 9.1 9.6 9.6 5.9-.5 9.1-3.7 9.6-9.6m-3.4 0c-.3 3.8-2.4 5.9-6.2 6.2-3.8-.3-5.8-2.4-6.2-6.2.4-3.8 2.5-5.8 6.2-6.2 3.8.4 5.9 2.5 6.2 6.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m168.2 89.4-2.7-.8-24.6 80.7-24.6-80.7-2.7.8 27.3 89.5 27.3-89.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.6 129.8c-.4-4.9-3.1-7.6-8.1-8.1-4.9.5-7.6 3.2-8.1 8.1.5 4.9 3.2 7.6 8.1 8.1 5-.4 7.7-3.1 8.1-8.1m-3.3 0c-.2 2.9-1.8 4.5-4.7 4.7-2.9-.2-4.4-1.8-4.7-4.7.3-2.9 1.9-4.4 4.7-4.7 2.9.3 4.4 1.9 4.7 4.7z",
    style: {
      fill: "#fff"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8 129.8c.4 5.4 3.4 8.3 8.8 8.8 5.3-.4 8.3-3.4 8.8-8.8-.5-5.3-3.4-8.3-8.8-8.8-5.4.5-8.4 3.4-8.8 8.8m14-5.3c1.4 1.4 2.1 3.1 2.2 5.2-.1 2.1-.8 3.8-2.2 5.2-1.4 1.4-3.1 2.1-5.2 2.2-2.1-.1-3.8-.8-5.2-2.2-1.4-1.4-2.1-3.1-2.2-5.2.1-2.1.8-3.8 2.2-5.2 1.4-1.4 3.1-2.1 5.2-2.2 2 .1 3.8.8 5.2 2.2m.3 5.3c-.3-3.3-2.2-5.1-5.6-5.4-3.3.3-5.1 2.1-5.4 5.4.3 3.3 2.1 5.1 5.4 5.4 3.4-.3 5.3-2.1 5.6-5.4m-5.5-4.1c2.4.3 3.8 1.6 4 4-.3 2.5-1.6 3.8-4 4-2.5-.2-3.8-1.6-4-4 .1-2.4 1.5-3.7 4-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.8 171.1 84.4 130H56.9l-9.6 41.1h46.5z",
    style: {
      fill: "#fff"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m85 129.9-.2-.5H56.2v.5l-9.8 42h48.2l-9.6-42m-1.2.8 9.2 39.8H48.1l9.4-39.8h26.3z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0002 0 0 1 53.115 163.762)",
    style: {
      fontSize: "13.4786px",
      fontFamily: "'ArialMT'"
    }
  }, "\n    20kg\n  "), /*#__PURE__*/React.createElement("path", {
    d: "m234.7 171.1-9.4-41.1h-27.5l-9.6 41.1h46.5z",
    style: {
      fill: "#fff"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m225.9 129.9-.2-.5h-28.6v.5l-9.8 42h48.2l-9.6-42m-1.3.8 9.2 39.8H189l9.4-39.8h26.2z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0002 0 0 1 193.965 163.762)",
    style: {
      fontSize: "13.4786px",
      fontFamily: "'ArialMT'"
    }
  }, "\n    20kg\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M546.8 146.5c-.5-4.9-3.2-7.6-8.1-8.1-5 .5-7.7 3.2-8.1 8.1.4 5 3.1 7.7 8.1 8.1 4.9-.4 7.6-3.1 8.1-8.1m-3.4 0c-.3 3-1.9 4.6-4.7 4.9-3-.3-4.6-1.9-4.9-4.9.3-2.9 1.9-4.4 4.9-4.7 2.8.3 4.4 1.8 4.7 4.7z",
    style: {
      fill: "#fff"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M529.8 146.5c.5 5.3 3.5 8.3 8.9 8.8 5.3-.5 8.2-3.4 8.8-8.8-.6-5.4-3.5-8.3-8.8-8.8-5.5.4-8.4 3.4-8.9 8.8m14.1-5.3c1.4 1.4 2.1 3.1 2.2 5.2-.1 2.1-.8 3.8-2.2 5.2s-3.1 2.1-5.2 2.2c-2.1-.1-3.8-.8-5.2-2.2s-2.1-3.1-2.2-5.2c.1-2.1.8-3.8 2.2-5.2s3.1-2.1 5.2-2.2c2.1.1 3.8.8 5.2 2.2m.2 5.3c-.3-3.3-2.1-5.1-5.4-5.4-3.4.3-5.2 2.1-5.6 5.4.3 3.4 2.2 5.2 5.6 5.6 3.3-.4 5.1-2.3 5.4-5.6m-5.4-4.1c2.4.2 3.8 1.6 4 4-.3 2.5-1.6 3.9-4 4-2.5-.2-3.9-1.5-4-4 .1-2.4 1.5-3.8 4-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M584.4 96.6c-1.3-14-8.9-21.6-22.7-22.9-14 1.3-21.7 8.9-22.9 22.9 1.2 13.9 8.9 21.6 22.9 22.9 13.8-1.3 21.4-9 22.7-22.9z",
    style: {
      fill: "#fff"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M561.5 72.9c-14.4 1.4-22.3 9.3-23.6 23.6 1.3 14.4 9.2 22.2 23.6 23.6 14.4-1.3 22.2-9.2 23.6-23.6-1.4-14.3-9.2-22.1-23.6-23.6m15.7 8c4.2 4.2 6.3 9.4 6.4 15.7-.1 6.2-2.2 11.5-6.4 15.7s-9.4 6.4-15.7 6.6c-6.4-.2-11.7-2.4-15.8-6.6s-6.2-9.4-6.4-15.7c.2-6.2 2.3-11.5 6.4-15.7 4.2-4.2 9.4-6.4 15.8-6.6 6.2.2 11.5 2.4 15.7 6.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M570.3 89.2c-2.5-2.7-5.4-4-8.8-4-2.6 0-5.1.9-7.3 2.7-4.9 4.9-5.4 10.3-1.5 16.2 2.5 2.6 5.5 4 8.8 4 2.7 0 5.1-.9 7.3-2.6 4.9-5.1 5.4-10.5 1.5-16.3z",
    style: {
      fill: "#999"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M573.6 96.5c0-2.9-1-5.4-2.9-7.8-2.7-2.9-5.8-4.4-9.3-4.4-2.9-.1-5.6.9-7.9 2.9-2.9 2.5-4.3 5.6-4.4 9.3 0 2.8 1 5.4 2.9 7.8 2.6 2.9 5.8 4.3 9.4 4.4 2.8-.1 5.3-1 7.8-2.9 2.9-2.6 4.4-5.7 4.4-9.3m-1.5 0c0 3.1-1.2 5.9-3.7 8.3-2.1 1.7-4.4 2.5-6.9 2.5-3.4-.1-6.1-1.3-8.3-3.9-1.7-2.1-2.5-4.4-2.5-6.9-.1-3.1 1.2-5.9 3.9-8.3 2.1-1.7 4.4-2.5 6.9-2.5 3.2 0 5.9 1.3 8.1 3.9 1.7 2 2.5 4.3 2.5 6.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M567.3 96.6c-.4-3.5-2.3-5.4-5.7-5.7-3.5.3-5.4 2.2-5.7 5.7.3 3.5 2.2 5.4 5.7 5.7 3.4-.3 5.3-2.2 5.7-5.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m561.9 187.8-9.6-41.1h-27.5l-9.4 41.1h46.5z",
    style: {
      fill: "#fff"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M553 146.5v-.5h-28.6l-.2.5-9.6 42h48.2l-9.8-42m-1.3.8 9.2 39.8h-44.7l9.2-39.8h26.3zm75.4 39.6v-29.3h-36.2v29.3h36.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M627.7 187.6v-30.7h-37.6v30.7h37.6m-1.3-29.1v27.8h-34.7v-27.8h34.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m614.5 157.6-2.2-6.9h-6.4l-2.4 6.9h11z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m615.2 157.4-2.4-7.4h-7.4l-2.7 8.4h12.6l-.1-1m-3.4-6.1 1.7 5.6h-8.9l1.9-5.6h5.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M618.6 147.8c-.6-5.8-3.8-9-9.6-9.6-5.9.6-9.1 3.8-9.6 9.6.5 5.8 3.7 9 9.6 9.6 5.8-.6 9-3.8 9.6-9.6m-3.4 0c-.4 3.8-2.5 5.9-6.2 6.2-3.8-.3-5.9-2.4-6.2-6.2.3-3.8 2.4-5.8 6.2-6.2 3.8.4 5.8 2.4 6.2 6.2z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0002 0 0 1 521.164 180.561)",
    style: {
      fontSize: "13.4786px",
      fontFamily: "'ArialMT'"
    }
  }, "\n    20kg\n  "), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m580.9 87.6 2.5-1.2c-4.4-8.8-11.7-13.5-21.9-14-14.9 1.3-23 9.4-24.4 24.3v46.8h2.9V96.7c.2-6.1 2.2-11.1 6.2-15.2 4-4 9.2-6.2 15.3-6.4 9.1.4 15.5 4.6 19.4 12.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M687.6 146.5c-.5-4.9-3.2-7.6-8.1-8.1-5 .5-7.7 3.2-8.1 8.1.4 5 3.1 7.7 8.1 8.1 4.9-.4 7.6-3.1 8.1-8.1m-3.4 0c-.3 3-1.9 4.6-4.7 4.9-3-.3-4.6-1.9-4.9-4.9.3-2.9 1.9-4.4 4.9-4.7 2.8.3 4.4 1.8 4.7 4.7z",
    style: {
      fill: "#fff"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M670.5 146.5c.6 5.3 3.5 8.3 8.9 8.8 5.3-.5 8.2-3.4 8.8-8.8-.6-5.4-3.5-8.3-8.8-8.8-5.3.4-8.3 3.4-8.9 8.8m14.2-5.3c1.4 1.4 2.1 3.1 2.2 5.2-.1 2.1-.8 3.8-2.2 5.2s-3.1 2.1-5.2 2.2c-2.2-.1-3.9-.8-5.2-2.2-1.4-1.4-2.1-3.1-2.2-5.2.1-2.1.8-3.8 2.2-5.2 1.3-1.4 3.1-2.1 5.2-2.2 2.1.1 3.8.8 5.2 2.2m.2 5.3c-.3-3.3-2.1-5.1-5.4-5.4-3.4.3-5.2 2.1-5.6 5.4.3 3.4 2.2 5.2 5.6 5.6 3.2-.4 5-2.3 5.4-5.6m-5.4-4.1c2.4.2 3.8 1.6 4 4-.3 2.5-1.6 3.9-4 4-2.5-.2-3.9-1.5-4-4 .1-2.4 1.5-3.8 4-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M679.4 96.6c-1.3-14-8.9-21.6-22.9-22.9-13.9 1.3-21.6 8.9-22.9 22.9 1.3 13.9 9 21.6 22.9 22.9 14-1.3 21.6-9 22.9-22.9z",
    style: {
      fill: "#fff"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M656.6 72.9c-14.4 1.4-22.3 9.3-23.6 23.6 1.3 14.4 9.2 22.2 23.6 23.6 14.4-1.3 22.2-9.2 23.6-23.6-1.3-14.3-9.2-22.1-23.6-23.6m15.7 8c4.2 4.2 6.3 9.4 6.4 15.7-.1 6.2-2.2 11.5-6.4 15.7s-9.4 6.4-15.7 6.6c-6.4-.2-11.6-2.4-15.7-6.6-4.2-4.2-6.4-9.4-6.6-15.7.2-6.2 2.4-11.5 6.6-15.7 4-4.2 9.3-6.4 15.7-6.6 6.3.2 11.5 2.4 15.7 6.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M663.8 87.9c-2.1-1.8-4.5-2.7-7.2-2.7-3.4 0-6.3 1.3-8.8 4-4 5.8-3.5 11.2 1.3 16.2 2.2 1.7 4.7 2.6 7.4 2.6 3.4 0 6.3-1.3 8.8-4 4-5.8 3.5-11.2-1.5-16.1z",
    style: {
      fill: "#999"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M668.7 96.5c0-3.7-1.5-6.7-4.4-9.3-2.4-2-4.9-2.9-7.8-2.9-3.7 0-6.8 1.5-9.3 4.4-2 2.4-2.9 4.9-2.9 7.8-.1 3.6 1.3 6.7 4.2 9.3 2.4 1.9 5.1 2.8 7.9 2.9 3.6-.1 6.7-1.5 9.3-4.4 2-2.4 3-5 3-7.8m-1.4 0c0 2.5-.8 4.8-2.5 6.9-2.4 2.5-5.1 3.8-8.3 3.9-2.5 0-4.8-.8-6.9-2.5-2.6-2.4-3.9-5.1-3.9-8.3 0-2.6.8-4.9 2.5-6.9 2.3-2.6 5.1-3.9 8.3-3.9 2.5 0 4.8.8 6.9 2.5 2.6 2.4 3.9 5.2 3.9 8.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M662.3 96.6c-.3-3.5-2.2-5.4-5.7-5.7-3.5.3-5.4 2.2-5.7 5.7.3 3.5 2.2 5.4 5.7 5.7 3.4-.3 5.3-2.2 5.7-5.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m702.5 187.8-9.4-41.1h-27.5l-9.4 41.1h46.3z",
    style: {
      fill: "#fff"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m693.8 146.5-.2-.5h-28.5l-.2.5-9.6 42h48.2l-.3-.8-9.4-41.2m-1.3.8 9.2 39.8H657l9.2-39.8h26.3zM580.8 87.5l28.1 60.3 28-60.3-2.5-1.2-25.5 54.9-25.5-54.9-2.6 1.2z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0002 0 0 1 662.015 180.561)",
    style: {
      fontSize: "13.4786px",
      fontFamily: "'ArialMT'"
    }
  }, "\n    20kg\n  "), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M671.7 81.5c4 4 6.1 9.1 6.2 15.2v46.8h2.9V96.7c-1.5-14.8-9.5-22.9-24.3-24.3-10.3.5-17.6 5.2-22.1 14l2.5 1.2c3.9-7.9 10.4-12 19.5-12.5 6.2.2 11.3 2.4 15.3 6.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.6 167.8c-.5-4.9-3.2-7.6-8.1-8.1-4.9.5-7.6 3.2-8.1 8.1.4 5 3.1 7.7 8.1 8.1 4.9-.4 7.6-3.1 8.1-8.1m-3.3 0c-.2 2.9-1.8 4.5-4.7 4.7-2.9-.2-4.5-1.8-4.7-4.7.2-2.9 1.8-4.5 4.7-4.7 2.9.2 4.4 1.8 4.7 4.7z",
    style: {
      fill: "#fff"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M295.9 167.9c.4 5.4 3.4 8.3 8.8 8.8 5.4-.5 8.3-3.4 8.8-8.8-.4-5.3-3.4-8.3-8.8-8.8-5.5.6-8.4 3.5-8.8 8.8m13.9-5.2c1.4 1.4 2.1 3.1 2.2 5.2-.1 2.1-.8 3.8-2.2 5.2-1.4 1.4-3.1 2.1-5.2 2.2-2.1-.1-3.8-.8-5.2-2.2-1.4-1.4-2.1-3.1-2.2-5.2.1-2.1.8-3.8 2.2-5.2 1.4-1.4 3.1-2.1 5.2-2.2 2.1.1 3.8.8 5.2 2.2m.2 5.2c-.3-3.3-2.1-5.1-5.4-5.4-3.3.3-5.1 2.1-5.4 5.4.3 3.3 2.1 5.1 5.4 5.4 3.3-.3 5.1-2.1 5.4-5.4m-5.4-4c2.5.3 3.8 1.6 4 4-.2 2.5-1.6 3.8-4 4-2.5-.2-3.8-1.6-4-4 .2-2.4 1.5-3.8 4-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.4 96.6c-1.3-14-8.9-21.6-22.9-22.9-13.9 1.3-21.6 8.9-22.9 22.9 1.3 13.9 9 21.6 22.9 22.9 14-1.3 21.6-9 22.9-22.9z",
    style: {
      fill: "#fff"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 72.9c-14.4 1.4-22.3 9.3-23.6 23.6 1.3 14.4 9.2 22.2 23.6 23.6 14.4-1.3 22.2-9.2 23.6-23.6-1.4-14.3-9.2-22.1-23.6-23.6m15.7 8c4.2 4.2 6.4 9.4 6.6 15.7-.2 6.2-2.4 11.5-6.6 15.7s-9.4 6.4-15.7 6.6c-6.4-.2-11.6-2.4-15.7-6.6-4.2-4.2-6.4-9.4-6.6-15.7.2-6.2 2.4-11.5 6.6-15.7 4-4.2 9.3-6.4 15.7-6.6 6.2.2 11.5 2.4 15.7 6.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M344.3 79.1c-4.6-4.3-10.2-6.6-16.9-6.7-14.8 1.3-22.9 9.4-24.3 24.3v68.6h2.7V96.7c.1-6.1 2.2-11.1 6.4-15.2 4-4 9.1-6.2 15.2-6.4 5.8.2 10.8 2.2 14.8 6.1l2.1-2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M336.2 89.2c-2.4-2.7-5.3-4-8.8-4-2.7 0-5.2.9-7.4 2.7-4.9 4.9-5.3 10.3-1.3 16.2 2.4 2.6 5.3 4 8.8 4 2.7 0 5.1-.9 7.2-2.6 5-5.1 5.5-10.5 1.5-16.3z",
    style: {
      fill: "#999"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M339.7 96.5c-.1-2.9-1-5.4-2.9-7.8-2.6-2.9-5.7-4.4-9.3-4.4-2.9-.1-5.6.9-7.9 2.9-2.9 2.5-4.3 5.6-4.2 9.3-.1 2.8.9 5.4 2.9 7.8 2.5 2.9 5.6 4.3 9.3 4.4 2.8-.1 5.4-1 7.8-2.9 2.7-2.6 4.2-5.7 4.3-9.3m-1.4 0c-.1 3.1-1.3 5.9-3.9 8.3-2.1 1.7-4.4 2.5-6.9 2.5-3.2-.1-6-1.3-8.3-3.9-1.7-2.1-2.5-4.4-2.5-6.9 0-3.1 1.3-5.9 3.9-8.3 2-1.7 4.3-2.5 6.9-2.5 3.1 0 5.9 1.3 8.3 3.9 1.7 2 2.5 4.3 2.5 6.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M333.2 96.6c-.3-3.5-2.2-5.4-5.7-5.7-3.5.3-5.4 2.2-5.7 5.7.3 3.5 2.2 5.4 5.7 5.7 3.4-.3 5.3-2.2 5.7-5.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m327.8 209.2-9.4-41.1h-27.6l-9.4 41.1h46.4z",
    style: {
      fill: "#fff"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m319 167.9-.2-.5h-28.6l-.2.5-9.6 42h48.2l-9.6-42m-1.4.8 9.4 39.8h-44.8l9.2-39.8h26.2zm75.4-15.8v-29.1h-36.1v29.1H393z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M393.7 153.8v-30.7h-37.4v30.7h37.4m-1.4-29.4v27.8h-34.7v-27.8h34.7z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m380.3 123.7-2.2-6.9h-6.4l-2.2 6.9h10.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m381 123.4-2.4-7.6h-7.4l-2.4 7.6-.3.8h12.8l-.3-.8m-3.4-6 1.8 5.6h-8.9l1.8-5.6h5.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M384.6 114c-.6-5.9-3.8-9.1-9.6-9.6-5.8.5-9 3.7-9.6 9.6.6 5.8 3.8 8.9 9.6 9.4 5.8-.5 9-3.6 9.6-9.4m-3.4 0c-.4 3.8-2.5 5.8-6.2 6.2-3.8-.4-5.9-2.5-6.2-6.2.3-3.8 2.4-5.9 6.2-6.2 3.7.3 5.8 2.4 6.2 6.2z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0002 0 0 1 287.065 201.811)",
    style: {
      fontSize: "13.4786px",
      fontFamily: "'ArialMT'"
    }
  }, "\n    20kg\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M453.5 167.8c-.5-4.9-3.2-7.6-8.1-8.1-4.9.5-7.6 3.2-8.1 8.1.4 5 3.1 7.7 8.1 8.1 4.9-.4 7.6-3.1 8.1-8.1m-3.4 0c-.3 2.9-1.9 4.5-4.7 4.7-2.9-.2-4.5-1.8-4.7-4.7.2-2.9 1.8-4.5 4.7-4.7 2.9.2 4.4 1.8 4.7 4.7z",
    style: {
      fill: "#fff"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M436.7 167.9c.4 5.4 3.4 8.3 8.8 8.8 5.3-.5 8.3-3.4 8.8-8.8-.5-5.3-3.4-8.3-8.8-8.8-5.4.6-8.4 3.5-8.8 8.8m14-5.2c1.4 1.4 2.1 3.1 2.2 5.2-.1 2.1-.8 3.8-2.2 5.2-1.4 1.4-3.1 2.1-5.2 2.2-2.1-.1-3.8-.8-5.2-2.2-1.4-1.4-2.1-3.1-2.2-5.2.1-2.1.8-3.8 2.2-5.2 1.4-1.4 3.1-2.1 5.2-2.2 2 .1 3.8.8 5.2 2.2m.2 5.2c-.3-3.3-2.1-5.1-5.4-5.4-3.3.3-5.1 2.1-5.4 5.4.3 3.3 2.1 5.1 5.4 5.4 3.3-.3 5.1-2.1 5.4-5.4m-5.4-4c2.4.3 3.8 1.6 4 4-.3 2.5-1.6 3.8-4 4-2.5-.2-3.8-1.6-4-4 .1-2.4 1.5-3.8 4-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M445.5 96.6c-1.3-14-9-21.6-22.9-22.9-14 1.3-21.6 8.9-22.9 22.9 1.3 13.9 8.9 21.6 22.9 22.9 13.9-1.3 21.5-9 22.9-22.9z",
    style: {
      fill: "#fff"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M422.5 72.9c-14.4 1.4-22.2 9.3-23.6 23.6 1.3 14.4 9.2 22.2 23.6 23.6 14.4-1.3 22.2-9.2 23.6-23.6-1.4-14.3-9.2-22.1-23.6-23.6m15.7 8c4.2 4.2 6.4 9.4 6.6 15.7-.2 6.2-2.4 11.5-6.6 15.7s-9.4 6.4-15.7 6.6c-6.2-.2-11.5-2.4-15.7-6.6s-6.4-9.4-6.6-15.7c.2-6.2 2.4-11.5 6.6-15.7s9.4-6.4 15.7-6.6c6.2.2 11.5 2.4 15.7 6.6z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M446.7 96.7c-1.3-14.8-9.4-22.9-24.3-24.3-6.7.2-12.3 2.4-16.9 6.7l2 2c4-3.9 9-5.9 14.8-6.1 6.1.2 11.1 2.4 15.2 6.4 4 4 6.2 9.1 6.4 15.2v68.6h2.7l.1-68.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430 87.9c-2.3-1.8-4.8-2.7-7.4-2.7-3.5 0-6.4 1.3-8.8 4-4 5.8-3.5 11.2 1.3 16.2 2.2 1.7 4.6 2.6 7.3 2.6 3.5 0 6.4-1.3 8.8-4 4-5.8 3.5-11.2-1.2-16.1z",
    style: {
      fill: "#999"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M434.6 96.5c0-3.7-1.5-6.7-4.4-9.3-2.3-2-4.9-2.9-7.8-2.9-3.6 0-6.7 1.5-9.3 4.4-2 2.4-2.9 4.9-2.9 7.8.1 3.6 1.5 6.7 4.4 9.3 2.4 1.9 4.9 2.8 7.8 2.9 3.7-.1 6.8-1.5 9.3-4.4 2-2.4 3-5 2.9-7.8m-1.3 0c0 2.5-.8 4.8-2.5 6.9-2.3 2.5-5.1 3.8-8.3 3.9-2.5 0-4.8-.8-6.9-2.5-2.5-2.4-3.8-5.1-3.9-8.3 0-2.6.8-4.9 2.5-6.9 2.4-2.6 5.1-3.9 8.3-3.9 2.6 0 4.9.8 6.9 2.5 2.6 2.4 3.9 5.2 3.9 8.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M428.3 96.6c-.3-3.5-2.2-5.4-5.7-5.7-3.5.3-5.4 2.2-5.7 5.7.3 3.5 2.2 5.4 5.7 5.7 3.5-.3 5.4-2.2 5.7-5.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m468.7 209.2-9.6-41.1h-27.5l-9.4 41.1h46.5z",
    style: {
      fill: "#fff"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M459.7 167.9v-.5h-28.6l-.2.5-9.6 42h48.2l-9.8-42m-1.2.8 9.4 39.8H423l9.2-39.8h26.3zM407.7 81l-2-2-30.7 29.5L344.4 79l-2 2 31.7 30.5 1 .8 1-.8L407.7 81z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0002 0 0 1 427.914 201.811)",
    style: {
      fontSize: "13.4786px",
      fontFamily: "'ArialMT'"
    }
  }, "\n    20kg\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M153.4 26.8c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6s-3.6 5.3-3.6 8.7 1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 140.917 40.368)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    1\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M383.6 26.8c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 371.117 40.368)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M620.5 26.8c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6s-3.6 5.3-3.6 8.7 1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 607.967 40.368)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    3\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem7A);
export default __webpack_public_path__ + "static/media/item7a.bb8dfee7872fc9739e7e52ed3ff2b2fd.svg";
export { ForwardRef as ReactComponent };